import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIllustrationError500Light = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 320 320",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M257.159 163.875V205.551L242.281 196.965L193.06 183.735L194.085 144.976L154.659 121.867L143.99 115.699L122.443 103.279V86.1094L257.159 163.875Z",
			fill: "#E9EBED",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M280.373 146.684V188.359C280.373 190.88 278.831 193.027 275.747 194.819L257.16 205.55V163.875L275.747 153.143C278.831 151.351 280.373 149.205 280.373 146.684Z",
			fill: "#E9EBED",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.6845 137.703C73.6845 139.349 72.6426 140.787 70.538 141.996C68.4334 143.225 65.9535 143.829 63.0988 143.809C60.2232 143.809 57.7437 143.204 55.6182 141.975C53.4928 140.745 52.43 139.308 52.43 137.661C52.4092 136.015 53.4719 134.577 55.5765 133.369C57.681 132.139 60.1609 131.535 63.0156 131.535C65.8912 131.535 68.3709 132.16 70.4963 133.39C72.6218 134.619 73.6845 136.057 73.6845 137.703Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.639 126.494L154.658 121.868L143.99 115.7L122.443 103.28L107.586 94.6953L77.8301 111.866L152.889 156.035L202.595 149.857L162.639 126.494ZM115.15 116.241C113.046 117.45 110.566 118.054 107.711 118.054C104.856 118.054 102.356 117.429 100.231 116.221C98.1259 114.991 97.0424 113.553 97.0424 111.907C97.0424 110.261 98.0843 108.823 100.189 107.594C102.293 106.385 104.773 105.781 107.649 105.781C110.524 105.781 112.983 106.406 115.109 107.635C117.234 108.844 118.297 110.282 118.297 111.949C118.318 113.595 117.255 115.033 115.15 116.241Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.889 156.035V195.348C152.889 195.348 161.76 185.876 171.576 184.762C180.5 183.749 199.258 190.079 199.258 190.079L202.595 149.857L152.889 156.035Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.889 156.035L77.8301 111.866L107.586 94.6953L122.443 103.28L143.99 115.7L154.658 121.868L162.639 126.494L202.595 149.857M152.889 156.035V195.348C152.889 195.348 161.76 185.876 171.576 184.762C180.5 183.749 199.258 190.079 199.258 190.079L202.595 149.857M152.889 156.035L202.595 149.857M115.15 116.241C113.046 117.45 110.566 118.054 107.711 118.054C104.856 118.054 102.356 117.429 100.231 116.221C98.1259 114.991 97.0424 113.553 97.0424 111.907C97.0424 110.261 98.0843 108.823 100.189 107.594C102.293 106.385 104.773 105.781 107.649 105.781C110.524 105.781 112.983 106.406 115.109 107.635C117.234 108.844 118.297 110.282 118.297 111.949C118.318 113.595 117.255 115.033 115.15 116.241Z",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.298 111.949C118.319 113.596 117.256 115.033 115.152 116.242C113.047 117.45 110.568 118.055 107.713 118.055C104.858 118.055 102.358 117.429 100.232 116.221C98.1277 114.991 97.0439 113.554 97.0439 111.908C97.0439 110.262 98.086 108.824 100.191 107.594C102.295 106.386 104.775 105.781 107.65 105.781C110.526 105.781 112.985 106.406 115.11 107.636C117.236 108.844 118.298 110.282 118.298 111.949Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M275.663 140.222L163.431 75.4173C160.305 73.6045 156.575 72.7083 152.22 72.6875C147.865 72.6875 144.136 73.5836 141.052 75.3756L122.443 86.1071L257.159 163.873L275.746 153.142C278.83 151.35 280.372 149.203 280.372 146.682C280.352 144.181 278.789 142.014 275.663 140.222ZM159.784 90.4829C157.659 91.6915 155.179 92.2958 152.325 92.2958C149.47 92.2958 146.969 91.6706 144.865 90.4412C142.739 89.2326 141.677 87.7949 141.656 86.1279C141.656 84.4817 142.698 83.0438 144.802 81.8352C146.907 80.6267 149.407 80.0224 152.262 80.0224C155.117 80.0224 157.617 80.6475 159.722 81.8561C161.847 83.0855 162.91 84.5235 162.931 86.1696C162.931 87.8366 161.889 89.2535 159.784 90.4829Z",
			fill: "#E9EBED",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M162.932 86.1707C162.932 87.8377 161.891 89.2545 159.786 90.484C157.661 91.6926 155.181 92.2968 152.326 92.2968C149.471 92.2968 146.971 91.6717 144.866 90.4423C142.741 89.2337 141.678 87.796 141.657 86.129C141.657 84.4828 142.699 83.0449 144.804 81.8363C146.908 80.6277 149.409 80.0234 152.264 80.0234C155.118 80.0234 157.619 80.6486 159.723 81.8572C161.849 83.0866 162.912 84.5245 162.932 86.1707Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.186 156.003V197.678L129.233 201.695V159.2L118.005 152.226L110.024 147.621L99.0636 141.286L77.8301 129.033V111.863L152.186 156.003Z",
			fill: "#E9EBED",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.753 158.68C129.753 158.68 88.7502 160.732 88.3111 170.217V213.82C89.7603 201.857 129.753 197.521 129.753 197.521V158.68Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M62.9535 120.449L44.3661 131.181C41.2822 132.973 39.7402 135.119 39.7402 137.64C39.7611 140.141 41.3239 142.308 44.4496 144.1L88.3111 170.217C88.7502 160.732 129.753 158.68 129.753 158.68L118.006 152.227L62.9535 120.449ZM63.0991 143.808C65.9539 143.829 68.4338 143.225 70.5384 141.995C72.643 140.787 73.6848 139.349 73.6848 137.703C73.6848 136.057 72.6221 134.619 70.4967 133.389C68.3712 132.16 65.8916 131.535 63.016 131.535C60.1612 131.535 57.6813 132.139 55.5768 133.369C53.4722 134.577 52.4095 136.015 52.4303 137.661C52.4303 139.307 53.4931 140.745 55.6185 141.974C57.7438 143.204 60.2235 143.808 63.0991 143.808Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.4496 144.1C41.3239 142.308 39.7611 140.141 39.7402 137.64V179.316C39.7611 181.816 41.3239 183.983 44.4496 185.775L88.3111 213.82V170.217L44.4496 144.1Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.7402 137.64C39.7402 135.119 41.2822 132.973 44.3661 131.181L62.9535 120.449L118.006 152.227L129.753 158.68M39.7402 137.64C39.7611 140.141 41.3239 142.308 44.4496 144.1L88.3111 170.217M39.7402 137.64V179.316C39.7611 181.816 41.3239 183.983 44.4496 185.775L88.3111 213.82M88.3111 170.217C88.7502 160.732 129.753 158.68 129.753 158.68M88.3111 170.217V213.82M129.753 158.68V197.521C129.753 197.521 89.7603 201.857 88.3111 213.82M70.5384 141.995C68.4338 143.225 65.9539 143.829 63.0991 143.808C60.2235 143.808 57.7438 143.204 55.6185 141.974C53.4931 140.745 52.4303 139.307 52.4303 137.661C52.4095 136.015 53.4722 134.577 55.5768 133.369C57.6813 132.139 60.1612 131.535 63.016 131.535C65.8916 131.535 68.3712 132.16 70.4967 133.389C72.6221 134.619 73.6848 136.057 73.6848 137.703C73.6848 139.349 72.643 140.787 70.5384 141.995Z",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.963 171.956C226.112 171.609 226.198 171.264 226.227 170.923L226.238 170.606C226.177 167.358 220.959 164.617 215.082 165.183L112.054 175.121C107.469 175.563 104.7 177.778 104.63 180.144C104.591 181.474 105.405 182.852 107.231 183.988L185.196 232.513C190.268 235.67 199.158 234.484 200.901 230.419L225.963 171.956Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M225.963 171.956L200.901 230.419C199.158 234.484 190.268 235.67 185.196 232.513L107.231 183.988C105.405 182.852 104.591 181.474 104.63 180.144L103.178 221.349C103.138 222.679 103.953 224.057 105.779 225.194L183.744 273.718C188.815 276.875 197.706 275.689 199.449 271.624L224.511 213.161C224.706 212.707 224.794 212.254 224.786 211.811L226.227 170.923C226.198 171.264 226.112 171.609 225.963 171.956Z",
			fill: "#E9EBED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M226.238 170.606C226.177 167.358 220.959 164.617 215.082 165.183L112.054 175.121C107.469 175.563 104.7 177.778 104.63 180.144M226.238 170.606L226.227 170.923M226.238 170.606C226.24 170.711 226.236 170.817 226.227 170.923M104.63 180.144C104.591 181.474 105.405 182.852 107.231 183.988L185.196 232.513C190.268 235.67 199.158 234.484 200.901 230.419L225.963 171.956C226.112 171.609 226.198 171.264 226.227 170.923M104.63 180.144L103.178 221.349C103.138 222.679 103.953 224.057 105.779 225.194L183.744 273.718C188.815 276.875 197.706 275.689 199.449 271.624L224.511 213.161C224.706 212.707 224.794 212.254 224.786 211.811L226.227 170.923",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M204.249 180.295C204.219 181.196 203.682 181.937 202.618 182.496L178.744 195.255C177.68 195.814 176.36 196.078 174.803 196.027C173.227 195.974 171.926 195.624 170.902 194.975C169.878 194.326 169.37 193.571 169.401 192.65C169.431 191.728 169.968 191.008 171.032 190.449L194.905 177.69C195.969 177.13 197.29 176.867 198.846 176.918C200.422 176.991 201.724 177.321 202.747 177.97C203.771 178.619 204.279 179.374 204.249 180.295Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M165.479 198.893C165.45 199.794 164.913 200.535 163.849 201.094C162.784 201.674 161.464 201.917 159.908 201.866C158.351 201.814 157.03 201.463 156.006 200.834C155.344 200.402 154.888 199.936 154.679 199.417C154.545 199.126 154.494 198.816 154.504 198.509C154.534 197.608 155.071 196.867 156.135 196.308C157.2 195.728 158.5 195.484 160.076 195.537C161.653 195.589 162.933 195.939 163.957 196.567C164.439 196.87 164.798 197.19 165.032 197.546C165.346 197.966 165.475 198.401 165.479 198.893Z",
			fill: "white",
			stroke: "#87929D",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIllustrationError500Light;
